import { api } from '@/lib/api/client';
import type {
  Complaint,
  ComplaintFilters,
  ComplaintsResponse,
  CreateComplaintDto,
  UpdateComplaintDto,
} from '../types';

const COMPLAINTS_URL = '/complaints';

export const complaintsApi = {
  getAll: async (filters?: ComplaintFilters): Promise<ComplaintsResponse> => {
    const params: Record<string, unknown> = { ...filters };

    if (params['page'] !== undefined && params['limit']) {
      params['offset'] = (params['page'] as number) * (params['limit'] as number);
      delete params['page'];
    }

    if (params['s'] && (params['s'] as string).length < 2) {
      delete params['s'];
    }

    if (params['createdAt.min']) {
      const minDate = new Date(params['createdAt.min'] as string);
      minDate.setHours(0, 0, 0, 0);
      params['createdAt.min'] = minDate.toISOString();
    }

    if (params['createdAt.max']) {
      const maxDate = new Date(params['createdAt.max'] as string);
      maxDate.setHours(23, 59, 59, 999);
      params['createdAt.max'] = maxDate.toISOString();
    }

    Object.keys(params).forEach((key) => {
      if (params[key] == null || params[key] === '') {
        delete params[key];
      }
    });

    if (!params['orderBy'] || !params['order']) {
      delete params['orderBy'];
      delete params['order'];
    }

    return api.get<ComplaintsResponse>(COMPLAINTS_URL, { params });
  },

  getById: async (id: number | string): Promise<Complaint> => {
    return api.get<Complaint>(`${COMPLAINTS_URL}/${id}`);
  },

  create: async (data: CreateComplaintDto): Promise<Complaint> => {
    return api.post<Complaint>(COMPLAINTS_URL, data);
  },

  update: async ({ id, data }: { id: number | string; data: UpdateComplaintDto }): Promise<Complaint> => {
    return api.patch<Complaint>(`${COMPLAINTS_URL}/${id}`, data);
  },

  delete: async (id: number | string): Promise<void> => {
    return api.delete(`${COMPLAINTS_URL}/${id}`);
  },
};

export const complaintsQueryKeys = {
  all: ['complaints'] as const,
  lists: () => [...complaintsQueryKeys.all, 'list'] as const,
  list: (filters?: ComplaintFilters) => [...complaintsQueryKeys.lists(), filters] as const,
  details: () => [...complaintsQueryKeys.all, 'detail'] as const,
  detail: (id: number | string) => [...complaintsQueryKeys.details(), id] as const,
};
